import { CSSProperties, forwardRef } from 'react';

const Item = forwardRef<HTMLDivElement, any>((props, ref) => {
  const { withOpacity, isDragging, style, disabled } = props;
  const inlineStyles: CSSProperties = {
    opacity: withOpacity ? '0.1' : '1',
    cursor: disabled ? 'default' : isDragging ? 'grabbing' : 'grab',
    transform: isDragging ? 'scale(1.05)' : 'scale(1)',
    ...style,
  };
  return (
    <div {...props} style={inlineStyles} ref={ref}>
      {props.children}
    </div>
  );
});
export default Item;
